import { Component, OnInit } from '@angular/core';
import { ControllerService } from '../shared/services/controller.service';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from '../../environments/environment';

@Component({
    selector: 'app-podcast',
    templateUrl: './podcast.component.html',
    styleUrls: ['./podcast.component.scss'],
    standalone: false
})
export class PodcastComponent implements OnInit {

  podcastId: string

  podcastBaseUrl = 'https://player.captivate.fm/episode/'

  publishDate = ''

  episodeTitle = ''

  image = ''

  component: any


  constructor(public controller: ControllerService, private doms: DomSanitizer) { }

  sanitizeUrl( url ){
    return this.doms.bypassSecurityTrustUrl( url )
  }

  sanitizeHtml( innerHtml ){
    return this.doms.bypassSecurityTrustHtml( innerHtml )
  }

  getPodcastImageUrl(){
    return this.doms.bypassSecurityTrustResourceUrl( environment.audioBaseDir + '/library/images/' + this.image )
  }


  getPodcastUrl(){

    return this.doms.bypassSecurityTrustResourceUrl( this.podcastBaseUrl + this.podcastId )
  }

  ngOnInit() {


    this.component = this.controller.getSectionComponents()[0]

    this.podcastId = this.component.properties.podcastId
    this.episodeTitle = this.component.properties.episodeTitle
    this.publishDate = this.component.properties.publishDate
    this.image = this.component.properties.image

    console.log(this.component)
  }

}
